import { AuthGuard } from '@auth';
import { ProfilePageWrapper } from '@profile';
import styled from 'styled-components';

const TuitionIframe = styled.iframe`
  border: 1px solid ${(props) => props.theme.lightGrey.string()};
  min-height: 60vh;
  width: 100%;
`;

export default function TuitionAssessmentToolPage() {
  return (
    <ProfilePageWrapper pageTitle="Tuition Assessment Tool">
      <AuthGuard>
        <TuitionIframe src="/temp-tat/index.html"></TuitionIframe>
      </AuthGuard>
    </ProfilePageWrapper>
  );
}
